import LazyLoad from "vanilla-lazyload";

export const lazyContent = new LazyLoad({
    use_native: false
});
